export const LinesLinkedTypes = [
  Object.freeze({
    id: " ",
    name: "All",
  }),
  Object.freeze({
    id: "true",
    name: "LinesLinked",
  }),
  Object.freeze({
    id: "false",
    name: "LinesNotLinked",
  }),
];

export const getLinesLinkedTypesIdByName = (name) => {
  return (
    LinesLinkedTypes.find((x) => x.name === name)?.id ||
    ""
  );
};

export const getLinesLinkedTypesNameById = (id) => {
  return (
    LinesLinkedTypes.find((x) => x.id === id)?.name ||
    ""
  );
};

export const getLinesLinkedTypesById = (id) => {
  return LinesLinkedTypes.find((x) => x.id === id) || "";
};
